module.exports = __webpack_public_path__ + "img/tutor-speaker-photo.70de085.png";